import { BasicDialogProperties } from "../../../../basic/view/dialogs/BasicDialogProperties";

export class Poker2TakeSeatDialogProperties extends BasicDialogProperties {
    public seatId: number = 0;
    public showTablePrice: boolean = false;
    public bookTime: number = NaN;
    public type: number = 0;

    constructor(seatId: number, showTablePrice: boolean, bookTime: number, type: number) {
        super();

        this.seatId = seatId;
        this.showTablePrice = showTablePrice;
        this.bookTime = bookTime;
        this.type = type;
    }
}
